import { Component, Input, OnInit } from "@angular/core";
import { NavigationItem, NavigationService } from "../../../layout/admin/navigation/navigation";
import {
  Router,
  UrlTree,
  UrlSegmentGroup,
  PRIMARY_OUTLET,
  UrlSegment,
  ActivatedRoute,
} from "@angular/router";
import { Title } from "@angular/platform-browser";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Component({
  selector: "app-breadcrumb",
  templateUrl: "./breadcrumb.component.html",
  styleUrls: ["./breadcrumb.component.scss"],
})
export class BreadcrumbComponent implements OnInit {
  @Input() type: string;

  public navigation: any;
  breadcrumbList: Array<any> = [];
  public navigationList: Array<any> = [];

  constructor(
    private route: Router,
    activatedRoute: ActivatedRoute,
    public nav: NavigationService,
    private titleService: Title
  ) {
    this.navigation = this.nav.get();
    this.type = "theme2";
    this.setBreadcrumb();
  }

  ngOnInit() {
    let routerUrl: string = "/";
    const urlTree = this.route.parseUrl(this.route.url);
    routerUrl += urlTree.root.children["primary"].segments
      .map((it) => it.path)
      .join("/");

    if (routerUrl && typeof routerUrl === "string") {
      this.filterNavigation(routerUrl);
    }
  }

  setBreadcrumb() {
    let routerUrl: string;
    this.route.events.subscribe((router: any) => {
      routerUrl = router.urlAfterRedirects;

      if (routerUrl && typeof routerUrl === "string") {
        let activeLink: string = "/";
        this.breadcrumbList.length = 0;
        const urlTree = this.route.parseUrl(this.route.url);
        activeLink += urlTree.root.children["primary"].segments
          .map((it) => it.path)
          .join("/");

        this.filterNavigation(activeLink);
      }
    });
  }

  filterNavigation(activeLink) {
    let result = [];
    let title = "Welcome";
    this.navigation.forEach((a) => {
      if (a.type === "item" && "url" in a && a.url === activeLink) {
        result = [
          {
            url: "url" in a ? a.url : false,
            title: a.title,
            breadcrumbs: "breadcrumbs" in a ? a.breadcrumbs : true,
            type: a.type,
          },
        ];
        title = a.title;
      } else {
        if (a.type === "group" && "children" in a) {
          a.children.forEach((b) => {
            if (b.type === "item" && "url" in b && b.url === activeLink) {
              result = [
                {
                  url: "url" in b ? b.url : false,
                  title: b.title,
                  breadcrumbs: "breadcrumbs" in b ? b.breadcrumbs : true,
                  type: b.type,
                },
              ];
              title = b.title;
            } else {
              if (b.type === "collapse" && "children" in b) {
                b.children.forEach((c) => {
                  if (c.type === "item" && "url" in c && c.url === activeLink) {
                    result = [
                      {
                        url: "url" in b ? b.url : false,
                        title: b.title,
                        breadcrumbs: "breadcrumbs" in b ? b.breadcrumbs : true,
                        type: b.type,
                      },
                      {
                        url: "url" in c ? c.url : false,
                        title: c.title,
                        breadcrumbs: "breadcrumbs" in c ? c.breadcrumbs : true,
                        type: c.type,
                      },
                    ];
                    title = c.title;
                  } else {
                    if (c.type === "collapse" && "children" in c) {
                      c.children.forEach((d) => {
                        if (
                          d.type === "item" &&
                          "url" in d &&
                          d.url === activeLink
                        ) {
                          result = [
                            {
                              url: "url" in b ? b.url : false,
                              title: b.title,
                              breadcrumbs:
                                "breadcrumbs" in b ? b.breadcrumbs : true,
                              type: b.type,
                            },
                            {
                              url: "url" in c ? c.url : false,
                              title: c.title,
                              breadcrumbs:
                                "breadcrumbs" in c ? c.breadcrumbs : true,
                              type: c.type,
                            },
                            {
                              url: "url" in d ? d.url : false,
                              title: d.title,
                              breadcrumbs:
                                "breadcrumbs" in c ? d.breadcrumbs : true,
                              type: d.type,
                            },
                          ];
                          title = d.title;
                        } else {
                          if (d.type === "collapse" && "children" in d) {
                            d.children.forEach((e) => {
                              if (
                                e.type === "item" &&
                                "url" in e &&
                                e.url === activeLink
                              ) {
                                result = [
                                  {
                                    url: "url" in b ? b.url : false,
                                    title: b.title,
                                    breadcrumbs:
                                      "breadcrumbs" in b ? b.breadcrumbs : true,
                                    type: b.type,
                                  },
                                  {
                                    url: "url" in c ? c.url : false,
                                    title: c.title,
                                    breadcrumbs:
                                      "breadcrumbs" in c ? c.breadcrumbs : true,
                                    type: c.type,
                                  },
                                  {
                                    url: "url" in d ? d.url : false,
                                    title: d.title,
                                    breadcrumbs:
                                      "breadcrumbs" in d ? d.breadcrumbs : true,
                                    type: d.type,
                                  },
                                  {
                                    url: "url" in e ? e.url : false,
                                    title: e.title,
                                    breadcrumbs:
                                      "breadcrumbs" in d ? e.breadcrumbs : true,
                                    type: e.type,
                                  },
                                ];
                                title = e.title;
                              } else {
                                if (e.type === "collapse" && "children" in e) {
                                  e.children.forEach((f) => {
                                    if (
                                      f.type === "item" &&
                                      "url" in f &&
                                      f.url === activeLink
                                    ) {
                                      result = [
                                        {
                                          url: "url" in b ? b.url : false,
                                          title: b.title,
                                          breadcrumbs:
                                            "breadcrumbs" in b
                                              ? b.breadcrumbs
                                              : true,
                                          type: b.type,
                                        },
                                        {
                                          url: "url" in c ? c.url : false,
                                          title: c.title,
                                          breadcrumbs:
                                            "breadcrumbs" in c
                                              ? c.breadcrumbs
                                              : true,
                                          type: c.type,
                                        },
                                        {
                                          url: "url" in d ? d.url : false,
                                          title: d.title,
                                          breadcrumbs:
                                            "breadcrumbs" in d
                                              ? d.breadcrumbs
                                              : true,
                                          type: d.type,
                                        },
                                        {
                                          url: "url" in e ? e.url : false,
                                          title: e.title,
                                          breadcrumbs:
                                            "breadcrumbs" in e
                                              ? e.breadcrumbs
                                              : true,
                                          type: e.type,
                                        },
                                        {
                                          url: "url" in f ? f.url : false,
                                          title: f.title,
                                          breadcrumbs:
                                            "breadcrumbs" in e
                                              ? f.breadcrumbs
                                              : true,
                                          type: f.type,
                                        },
                                      ];
                                      title = f.title;
                                    }
                                  });
                                }
                              }
                            });
                          }
                        }
                      });
                    }
                  }
                });
              }
            }
          });
        }
      }
    });
    this.navigationList = result;
    this.titleService.setTitle(title + " | NubiaEMR");
  }

  getHomeLink(): string {
    if (this.nav.auth.isGodMode()) {
      return '/dashboard/admin';
    }
    const role = this.nav.auth.role();
    if (role === 'Staff') {
      return '/dashboard/staff';
    }
    return '/dashboard/admin';
  }
}
